module.exports = __webpack_public_path__ + "media/images/flags/be-1a51c785fb867760b70096f31e38855d.svg";